import { render } from "./Info3.vue?vue&type=template&id=251a1f44&scoped=true"
import script from "./Info3.vue?vue&type=script&lang=js"
export * from "./Info3.vue?vue&type=script&lang=js"

import "./Info3.vue?vue&type=style&index=0&id=251a1f44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251a1f44"]])

export default __exports__